<template>
	<div>
		<!-- Precio unitario -->
		<div class="d-flex flex-column align-end">
			<div class="d-flex align-center">
				<h1 class="black--text">
					{{ priceFormat(Price) }}
				</h1>
				<v-chip small color="success" class="ml-2">
					{{ `-${99}% OFF` }}
				</v-chip>
			</div>

			<div>
				Antes:
				<span style="text-decoration: line-through;">
					{{ priceFormat(100) }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import Article from "@/clas/Article";

export default {
	name: "Price",

	props: ["article"],

	data() {
		return {};
	},

	created() {},

	methods: {
		priceFormat(val) {
			let a = new Article();

			return `${a.priceFormat(val)} MXN`;
		},
	},

	computed: {
		Price() {
			let amount = this.article.amount;

			if (this.article.box_capacity) {
				amount = amount * this.article.box_capacity;
			}

			return this.article.base_price * amount;
		},

		HasDiscount() {
			let a = new Article(this.article);

			return a.hasDiscount();
		},
	},
};
</script>

<style lang="css" scoped></style>
